import { takeEvery, fork, put, call, all } from "redux-saga/effects";
// Import Routes
import { authProtectedRoutes } from "../../routes";

// Login Redux States
import { SET_PROFILE } from "./actionTypes";
import { setUserInfo, setUserRoute } from "./actions";

function* editProfile({ payload: { info, history } }) {
  console.log("PROFILE SAGA SEND TO dashboard");
  console.log(info);
  yield put(setUserRoute(authProtectedRoutes));

  setTimeout(() => {
    history.push("/dashboard");
  }, 1000);
}

function* watchProfile() {
  // yield takeEvery(SET_PROFILE, editProfile);
}

export default watchProfile;
